/**
 * Função utilitária para detectar se estamos em ambiente de desenvolvimento/teste
 * para evitar registrar dados falsos no analytics e banco de dados
 */

export const isDevelopmentEnvironment = (): boolean => {
  // Detecta se estamos em modo de desenvolvimento do Vite
  if (import.meta.env?.DEV) {
    return true;
  }

  // Detecta URLs de desenvolvimento
  const hostname = window.location.hostname;
  const developmentHosts = [
    'localhost',
    '127.0.0.1',
    '0.0.0.0',
    'preview.lovable.app',
    'staging.lovable.app'
  ];

  if (developmentHosts.includes(hostname)) {
    return true;
  }

  // Detecta se é uma URL temporária do Lovable (padrão: *.lovable.app que não seja o domínio final)
  if (hostname.includes('lovable.app') && !hostname.startsWith('www.')) {
    return true;
  }

  // Detecta parâmetros de teste na URL
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('test') === 'true' || urlParams.get('debug') === 'true') {
    return true;
  }

  // Detecta se está sendo executado em iframe (preview do Lovable)
  if (window.self !== window.top) {
    return true;
  }

  return false;
};

export const shouldSkipTracking = (): boolean => {
  return isDevelopmentEnvironment();
};

export const logDebugInfo = (message: string, data?: any) => {
  if (isDevelopmentEnvironment()) {
    console.log(`🧪 [DEV MODE] ${message}`, data);
  }
};